export default {"src":"/_next/static/media/exterior-surface.8781fe8b.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};